module.exports = __webpack_public_path__ + "static/media/MagicVision_White.891a7c0a.png";